<script lang="ts">
  import {
    Blur,
    getBGSections,
    getBGHeaderPoints,
    type SectionConfig
  } from './BackgroundGradient.svelte';

  let cssLinear = 'white';
  let cssPoints = '';
  let cssFallback = '';

  export let pageHeight = 1;
  export let sectionConfig: SectionConfig[] = [];

  // update Points
  $: if (sectionConfig.length > 0) {
    const bgHeaderPoints = getBGHeaderPoints(sectionConfig);
    const bgSections = getBGSections(sectionConfig);
    const points: string[] = [];

    //this helps mobile safari not have visual glitch on scroll
    points.push(`linear-gradient(rgba(0,0,0,0) 0%, transparent 100%)`);

    const linears: string[] = [];
    bgSections.forEach((section) => {
      if (section.color[0] == -1) {
        bgHeaderPoints.forEach((point) => {
          const size = '35vw';
          const position = `${point.position[0] * 100}% ${
            point.position[1] * (bgSections[0]?.end || 500)
          }px`;
          const rgb255 = point.color.map((n) => Math.abs(n) * 255);
          const color1 = `rgb(${rgb255.join(', ')})`;

          points.push(`radial-gradient(circle at ${position}, ${color1}, transparent ${size})`);
        });
      }

      //build CSS values
      const start = Math.round((section.start / pageHeight) * 10000) / 100;
      const end = Math.round((section.end / pageHeight) * 10000) / 100;
      const sectionBlur = Math.round(Blur * (end - start)) / 100;

      let rgb255 = section.color.map((n) => Math.abs(n) * 255);
      if (section.color[0] < 0) {
        rgb255 = bgHeaderPoints[1].color.map((n) => Math.abs(n) * 255);
      }
      const rgba = `rgb(${rgb255.join(', ')})`;

      linears.push(`${rgba} ${start + sectionBlur}%`);
      linears.push(`${rgba} ${end - sectionBlur}%`);
    });

    cssPoints = points.join(', ');
    cssLinear = `linear-gradient(${linears.join(', ')})`;

    cssFallback = `${cssPoints}, ${cssLinear}`;
  }
</script>

<div class="gradient" style="background: {cssFallback}; height: {pageHeight}px" />

<style lang="scss">
  .gradient {
    max-width: 2800px;
    margin: var(--twist-core-spacing-0) auto;
    z-index: -99;
    position: absolute;
    width: 100vw;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
  }
</style>
